import type { DocumentUploaderItem } from '@app/shared/types/sf-data'

export type DirectUploadDocumentPayload = {
  document_attributes: {
    document_direct_upload_path: string
  }
}

export type PitExistingDocumentPayload = {
  document_attributes: {
    id: number
  }
}

export type ExistingDocumentPayload = {
  document_attributes: {
    document_id: number
  }
}

export type ExistingPermanentDocumentPayload = {
  document_attributes: {
    copy_from_permanent_document_id: number
  }
}

export type DocumentPayload =
  | DirectUploadDocumentPayload
  | PitExistingDocumentPayload
  | ExistingDocumentPayload
  | ExistingPermanentDocumentPayload

export enum ExtraDocumentLinkTypes {
  ProposedDocument = 'ProposedDocument',
}

export type LastOCRRequestParamsByAccountId = {
  ledgerId: number
  accountId: number
}

export type LastOCRRequestParamsByReconciliationTextId = {
  ledgerId: number
  reconciliationTextId: number
}

export type LastOCRRequestParams =
  | LastOCRRequestParamsByAccountId
  | LastOCRRequestParamsByReconciliationTextId

export type ErrorMessage = {
  documentId: number
  filename: string
  key: string
  params: Record<string, unknown>
}

export type LastOCRDocument = {
  id: number
  permanentDocumentId: number
  'forPermanentEntry?': boolean
  documentFileSize: number | null
  documentFilename: string
}

export type LastOCRRequest = {
  aiOcrRequest: {
    id: string
    documents: Array<LastOCRDocument>
    localizedErrorMessages: Array<ErrorMessage>
    status: LastOCRRequestStatus
    reconciliationProposal: {
      status: LastOCRRequestProposalStatus
    }
  }
  polling: {
    channel: string
    lastId: number
  }
}

export enum LastOCRRequestStatus {
  Unsent = 'unsent',
  Sent = 'sent',
  Completed = 'completed',
  Failed = 'failed',
  Retried = 'retried',
}

export enum LastOCRRequestProposalStatus {
  Open = 'open',
  InProgress = 'in_progress',
  Submitted = 'submitted',
  Accepted = 'accepted',
  Rejected = 'rejected',
}

export type ProposedDocument = {
  id: number
  linkType: ExtraDocumentLinkTypes.ProposedDocument
  name: string
}

type WithId<T> = T & {
  document_id?: number
  id: number | string
  viewingId?: string
}

type EnhancedDocumentUploaderItem = DocumentUploaderItem extends infer U
  ? WithId<U>
  : never

export type StoredDocument =
  | EnhancedDocumentUploaderItem
  | (ProposedDocument & { document_id?: number })

export type StoredDocuments = Record<string, StoredDocument>

export enum UIState {
  Edit = 'edit',
  Initial = 'initial',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
  PartialError = 'partialError',
  WaitingForMB = 'waitingForMB',
}
